import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2616d49b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=2616d49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616d49b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopFooterImageDesktop: require('/app/components/Theme2/Desktop/FooterImageDesktop.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
